import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { envConfig } from '~/utils/env';
import type {
  MaintenanceRequestSettings,
  MaintenanceRequestSettingsCompanyPortalTypedSettingsWithOverridesDocument,
} from '~/swagger/settings/Api';

const SETTINGS_BASE_URL = `${envConfig.service.settings}/company-portal/settings`;
const MAINTENANCE_REQUEST_SETTINGS_URL = `${SETTINGS_BASE_URL}/maintenancerequest`;

export class maintenanceRequestSettingsRepository extends BaseRestRepository {
  public async addMaintenanceRequestSettings(payload: MaintenanceRequestSettings) {
    const url = `${MAINTENANCE_REQUEST_SETTINGS_URL}/company`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload }),
    });
    return this.getJsonResponse(response);
  }

  public async addMaintenanceRequestSettingsByLevel(level: string, levelId: string, payload: MaintenanceRequestSettings) {
    const url = MAINTENANCE_REQUEST_SETTINGS_URL;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload, targets: [{ level, levelId }] }),
    });
    return this.getJsonResponse(response);
  }

  public async getMaintenanceRequestSettings(): Promise<MaintenanceRequestSettings> {
    const url = `${MAINTENANCE_REQUEST_SETTINGS_URL}/company`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async getMaintenanceRequestSettingsByLevel(level: string, levelId: string) {
    const url = `${MAINTENANCE_REQUEST_SETTINGS_URL}/${level}/${levelId}`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async getAllMaintenanceRequestSettings(): Promise<MaintenanceRequestSettingsCompanyPortalTypedSettingsWithOverridesDocument> {
    const url = `${MAINTENANCE_REQUEST_SETTINGS_URL}/with-overrides`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async deleteMaintenanceRequestSettingsByLevel(level: string, levelId: string) {
    const url = `${MAINTENANCE_REQUEST_SETTINGS_URL}/${level}/${levelId}`;
    const response = await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
    return this.getJsonResponse(response);
  }
}
